<template>
  <div class="table-container">
    <div v-if="alertMessage" class="custom-alert">
      {{ alertMessage }}
    </div>
    <table>
      <thead>
        <tr>
          <th v-for="(column, index) in columns" :key="index">{{ column }}</th>
        </tr>
      </thead>
      <!-- <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td v-for="(column, colIndex) in columns" :key="colIndex">
            <template v-if="column === 'Operador Real'">
              <select class="input-field" v-model="item.operadorReal">
                <option value="Pertenece">Pertenece</option>
                <option value="No Pertenece">No Pertenece</option>
              </select>
            </template>
            <template v-else>
              {{ item[getPropertyName(column)] }}
            </template>
          </td>
        </tr>
      </tbody> -->
      <tbody v-if="items.length > 0">
        <tr v-for="(item, index) in items" :key="index">
          <td v-for="(column, colIndex) in columns" :key="colIndex">
            <template v-if="column === 'Operador Real'">
              <select class="input-field" v-model="item.operadorReal">
                <option value="Pertenece">Pertenece</option>
                <option value="No Pertenece">No Pertenece</option>
              </select>
            </template>
            <template v-else>
              {{ item[getPropertyName(column)] }}
            </template>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td :colspan="columns.length" class="empty-message">
            No hay datos disponibles
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import IberoHelpers from '@/store/helpers.js'

export default {
  components: {
    IberoHelpers,
  },
  data () {
    return {
      alertMessage: '',
    }
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
  },
  methods: {
    showAlert (message) {
      this.alertMessage = message

      // Oculta el alert después de 3 segundos
      setTimeout(() => {
        this.alertMessage = ''
      }, 5000)
    },
    // Función para convertir el nombre de la columna a la propiedad camelCase correspondiente
    getPropertyName (column) {
      const columnMap = {
        'ID Banner': 'idBanner',
        'Cédula': 'cedula',
        'Nombres': 'nombres',
        'Período': 'periodo',
        'Operador Consolidado': 'operadorConsolidado',
        'Operador Banner': 'operador',
      }
      return columnMap[column] || column.toLowerCase().replace(/ /g, '')
    },
    sendDataOperators () {
      const emptyFields = this.items.some(item => !item.operadorReal || item.operadorReal.trim() === '')
      if (emptyFields) {
        this.showAlert('Todos los campos "Operador Real" deben estar llenos.')
      } else {
        IberoHelpers.PostOperatorFirstPart(this.$store, this.items)
          .then(() => {
            // Emitir el evento después de que PostAnulados termine
            this.$emit('nextModal')
            console.log(this.items)
          })
          .catch((error) => {
            console.error('Error al ejecutar PostAnulados:', error)
            // Opcional: manejar el error, como mostrar un mensaje al usuario
          })
      }
    },
  },
}
</script>